/*
 * Module for the Beneficiary Selection Step of the MemberDirect Employment Separation Options Wizard
*/
rs.module("content/communications/onlineforms/employmentseparationoptions/beneficiaryselectionstep",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, listApi) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var deathBeneficiaryActionKeyHidden = stepContainer.js(jsSelectors.deathBeneficiaryActionKeyHidden);

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // Get the form (this will be the wizard form)
            var _form = stepContainer.closest("form");

            // Reset validation
            $.validator.resetValidation(_form);

            // Handle list item click event 
            listApi.onItemClick(function (e, context) {

                // Set the death beneficiary action key hidden field to the recordKey of the clicked item in the list
                deathBeneficiaryActionKeyHidden.val(context.recordKey);

                // Advance the wizard to the next step (Death Beneficiary Detail step)
                wizardNextButton.click()
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);